import React, { useRef, useState } from "react";
import InputText from "../InputText";
import { validateFile } from "../../utils/helper";
import { postMultipart } from "../../utils/api";

const ActivityEntry = ({ plan, onUpdate }) => {
  const fileInputRef = useRef(null);
  const [uploadError, setUploadError] = useState(null);

  const handleFileChange = async (file) => {
    const err = validateFile(file);
    if (err) { setUploadError(err); return; }
    setUploadError(null);
    const fd = new FormData();
    fd.append("image", file);
    try {
      const data = await postMultipart("/api/dashboard/upload/activity-image", fd);
      onUpdate("image", data.url);
    } catch {
      setUploadError("Upload failed. Please try again.");
    }
  };

  const handleRemoveImage = () => {
    onUpdate("image", "");
  };

  return (
    <div className="">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Description</label>
          <textarea
            className="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
            placeholder="Detailed description of this stop..."
            value={plan.description || ""}
            rows={3}
            onChange={(e) => {
              const safeValue = e.target.value.replace(/'/g, "`");
              onUpdate("description", safeValue);
            }}
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Image</label>
          {plan.image ? (
            <div className="relative w-32 h-20">
              <img
                src={plan.image}
                alt="Stop preview"
                className="w-32 h-20 object-cover rounded-md border"
                onError={(e) => { e.target.style.display = "none"; }}
              />
              <button
                onClick={handleRemoveImage}
                type="button"
                className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full text-xs flex items-center justify-center leading-none hover:bg-red-600 shadow-sm"
              >
                ×
              </button>
            </div>
          ) : (
            <>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                className="hidden"
                id={`activity-upload-${plan.id}`}
                onChange={(e) => { const f = e.target.files?.[0]; if (f) handleFileChange(f); e.target.value = ""; }}
              />
              <label
                htmlFor={`activity-upload-${plan.id}`}
                className="flex items-center justify-center gap-1 w-full h-[42px] border border-dashed border-gray-400 rounded-md cursor-pointer hover:bg-gray-50 text-sm text-gray-500 transition-colors"
              >
                <span className="material-symbols-outlined text-base">add_photo_alternate</span>
                Add Image
              </label>
              {uploadError && <p className="text-red-500 text-xs mt-1">{uploadError}</p>}
            </>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Latitude</label>
          <InputText
            placeholder="e.g. 32.2396"
            value={plan.lat || ""}
            onChange={(e) => onUpdate("lat", e.target.value)}
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Longitude</label>
          <InputText
            placeholder="e.g. 77.1887"
            value={plan.lng || ""}
            onChange={(e) => onUpdate("lng", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default ActivityEntry;
